import type { HelpdeskPluginCatalogPage } from "@repo/shared-types/helpdesk-plugins";
import { req } from "../../shared/web/client.ts";
import { normalizeCatalogPage } from "./catalog-page-cache.ts";

export async function fetchPluginCatalog(path: string): Promise<HelpdeskPluginCatalogPage> {
  const startedAt = performance.now();
  const page = await req<HelpdeskPluginCatalogPage>(path);
  // Counting the full request duration conservatively bounds age during server work and transit.
  const elapsedMs = performance.now() - startedAt;
  const localPage = { ...page };
  delete localPage.cacheExpiresAt;
  return normalizeCatalogPage(localPage, Date.now(), elapsedMs);
}
